<!-- Preview Controls -->
@if (!showEmailInline && showDevicePreviewSizeButtons && showDevicePreviewSizeButtonsOnResize) {
  <div class="email-preview-controls">
    <mat-button-toggle-group [value]="selectedPreviewSize" (valueChange)="setPreviewSize($event)" class="device-preview-size">
      @if (showDesktopButton) {
        <mat-button-toggle value="desktop">
          <mat-icon>computer</mat-icon>
          Desktop
        </mat-button-toggle>
      }
      @if (showTabletButton) {
        <mat-button-toggle value="tablet">
          <mat-icon>tablet_mac</mat-icon>
          Tablet
        </mat-button-toggle>
      }
      <mat-button-toggle value="mobile">
        <mat-icon>phone_iphone</mat-icon>
        Mobile
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>
}

<!-- Email Preview and Sourcecode -->
@if (html) {
  <div class="preview-iframe-container">
    <iframe
      #iframePreview
      sandbox="allow-same-origin allow-popups allow-popups-to-escape-sandbox"
      class="email-preview-iframe"
      [style.max-width]="emailPreviewWidth"
      [style.min-height]="showEmailInline ? '100vh' : null"
      [style.height]="showEmailInline ? iframeContentHeight : null"
      [srcdoc]="html | iTrustThisHtml"
      (load)="calculateIframeContentHeight()"
    ></iframe>
  </div>
} @else {
  <glxy-loading-spinner />
}
